import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import ModalWrapper from "../../Components/Common/Portals/ModalWrapper";
import MyEarning from "../../Components/Earning/MyEarning";
import Layout from "../../Components/Layout";
import Input from "../../Components/UiElement/FormElement/Input";
import useHttpHook from "../../Hooks/HttpHook";
import {
  GetPomoterCommissionDetials,
  GetPromoterWalletDetails,
  WithdrawPromoterAmount,
} from "../../utils/ApiConstant";
import { createObjectForPaginatedResult } from "../../utils/Helper";
import { PromoterLanguage } from "../../utils/Languages";
import { toast } from "react-toastify";
import MyEarningCommission from "../../Components/Earning/MyEarningCommission";
import { showErrorToast } from "../../utils/notify";

const initialDateRange = { startDate: "", endDate: "" };
const PromoterEarningPage = () => {
  const [details, setDetails] = useState({});
  const [loading, sendRequest, error] = useHttpHook();
  const [walletDetails, setWalletDetails] = useState({});
  const [isWalletModal, setIsWalletModal] = useState(false);
  const { userDetails } = useSelector((state) => state.user);
  const [timeSpanInput, setTimeSpanInput] = useState("");
  const [dateRange, setDateRange] = useState(initialDateRange);
  const [isDateRange, setIsdateRange] = useState(false);
  const [isShowDateFilter, setIsShowDateFilter] = useState(true);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    getDetails();
    getWallet();
  }, [timeSpanInput, isDateRange]);

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);
  const getDetails = async (page = 1) => {
    let query = isDateRange
      ? `&startDate=${dateRange.startDate}&endDate=${dateRange.endDate}`
      : `&timeSpan=${timeSpanInput}`;
    try {
      let response = await sendRequest(
        `${GetPomoterCommissionDetials}?page=${page}${query}`,
        {
          method: "get",
        }
      );
      if (page === 1) {
        setDetails(response.data);
      } else {
        setDetails((prevState) => {
          const data = createObjectForPaginatedResult(
            response.data,
            prevState?.topSalingEvents,
            "paginate"
          );
          return {
            ...prevState,
            topSalingEvents: data,
          };
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getWallet = async () => {
    try {
      const res = await sendRequest(GetPromoterWalletDetails, {
        method: "get",
      });
      if (res.status === 1) {
        setWalletDetails(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleChangeWalletModalState = () => {
    setIsWalletModal(!isWalletModal);
  };

  const handleWithdrawAmount = async (data) => {
    try {
      if (data) {
        console.log({ amount: parseFloat(data.amount) });
        console.log({
          walletAmout: parseFloat(walletDetails ? walletDetails.amount : 0),
        });
        if (walletDetails.amount === 0) {
          toast.error(
            "You cannot withdraw the amount as there is insufficient balance."
          );
          return;
        }

        if (
          parseFloat(data.amount) > 0 &&
          parseFloat(data.amount) <=
            parseFloat(walletDetails ? walletDetails.amount : 0)
        ) {
          const res = await sendRequest(WithdrawPromoterAmount, {
            method: "put",
            data,
          });
          if (res.status === 1) {
            getWallet();
            handleChangeWalletModalState();
          }
        } else {
          toast.error("Please Enter valid amount");
        }
      }
    } catch (error) {
      console.log({ error });
    }
  };

  const handleTimeSpan = (timeSpan) => {
    setIsdateRange(false);

    setDateRange(initialDateRange);

    setTimeSpanInput(timeSpan);
  };
  const handleDateRange = (e) => {
    let temp = { ...dateRange };
    temp[e.target.name] = e.target.value;
    setDateRange(temp);
  };
  const handleDateRangeSubmit = (e) => {
    e.preventDefault();
    setIsdateRange(true);
    setTimeSpanInput("");
    getDetails();
  };

  return (
    <Layout
      Heading={PromoterLanguage.Earning.heading}
      TitleMark={true}
      TitleMarkClassName="event-my-earnings-title-mark"
      TitleClassName="event-my-earnings-title"
      HeadClassName="event-my-earnings-head event-promo-earnings-head"
      ExtraclassName="event-promo-earnings-panel"
      activeMenuId="my-promotion-earnings"
      extraElement={
        <button
          className="event-promo-earnings-balance-btn"
          type="button"
          onClick={handleChangeWalletModalState}
        >
          Balance:{" "}
          {`USD ${parseFloat(walletDetails?.amount || 0).toFixed(2)}`}
        </button>
      }
    >
      <MyEarningCommission
        isError={error}
        isLoading={loading}
        details={details}
        setDetails={setDetails}
        getDetails={getDetails}
        dateRange={dateRange}
        handleTimeSpan={handleTimeSpan}
        handleDateRange={handleDateRange}
        timeSpanInput={timeSpanInput}
        handleDateRangeSubmit={handleDateRangeSubmit}
        isShowDateFilter={isShowDateFilter}
        walletDetails={walletDetails}
      />
      {isWalletModal && (
        <ModalWrapper
          formId="withdraw-amount"
          isButtonDisabled={
            walletDetails.amount === 0 || !userDetails.stripeConnectId
          }
          title="Wallet"
          CloseModalHandler={handleChangeWalletModalState}
          submitText="Withdraw"
        >
          <div className="d-flex flex-column">
            {!userDetails.stripeConnectId && (  
              <span className="text-danger text-15 text-center">
                You're not a eligibel to withdraw your amount. You need to
                complete the organizer registration process to withdraw the
                amount.
              </span>
            )}
            <div>
              <p className="text-14 text-regular text-dark">
                Balance:{" "}
                {`USD ${parseFloat(walletDetails?.amount || 0).toFixed(2)}`}
              </p>
            </div>
            <form
              id="withdraw-amount"
              onSubmit={handleSubmit(handleWithdrawAmount)}
            >
              <Input
                ValidationArr={[{ Type: "required" }]}
                WrapperClass="col-lg-12"
                element="number"
                FieldName="amount"
                Register={register}
                Errors={errors}
                placeholder="Enter Amount"
                Label="Withdraw Amount"
              />
            </form>
          </div>
        </ModalWrapper>
      )}
    </Layout>
  );
};

export default PromoterEarningPage;
